export class SocialUserSignUp {
    user: UserSignUp;
    socialId: string;
    type: string;
}
export class UserSignUp {
    id?: number;
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    isActive: boolean;
    licenceKey?: string;
    role: RoleUserSignUp;
}

export class RoleUserSignUp {
    id: number;
}


export class CustomerCounter {
    email: string;
    firstName: string;
    lastName: string;
    userKey: number;

    constructor(data: CustomerCounter) {
        this.email = data.email || null;
        this.firstName = data.firstName || null;
        this.lastName = data.lastName || null;
        this.userKey = data.userKey || null;
    }
}

export class CustomerDetails {
  userKey: number;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email?: string;
  address?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  actorKey?: number;
  actorCode?: string;

  constructor(userKey: number, firstName: string, lastName: string, phoneNumber: string, email: string, address: string, city: string, postalCode?: string, country?: string) {
      this.userKey = userKey;
      this.firstName = firstName;
      this.lastName = lastName;
      this.phoneNumber = phoneNumber;
      this.email = email;
  }
}

export class UserAdmin {
  key: number;
  userName: string;
  role: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email?: string;
  address?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  actorKey?: number;
  actorCode?: string;
  isInitialized: boolean;
}

